import { render, staticRenderFns } from "./Estatus.vue?vue&type=template&id=044f36f4&scoped=true"
import script from "./Estatus.vue?vue&type=script&lang=js"
export * from "./Estatus.vue?vue&type=script&lang=js"
import style0 from "./Estatus.vue?vue&type=style&index=0&id=044f36f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f36f4",
  null
  
)

export default component.exports